import { IStore } from '../rootReducer';
import { IBroadcastMessage, BROADCAST_MESSAGE_TYPE } from 'utils/constants';
import { sortBy } from 'lodash';

const BROADCAST_MESSAGE_TYPE_ORDER = new Map([
  [BROADCAST_MESSAGE_TYPE.ALERT, 0],
  [BROADCAST_MESSAGE_TYPE.WARNING, 1],
  [BROADCAST_MESSAGE_TYPE.INFO, 2],
  [BROADCAST_MESSAGE_TYPE.NEUTRAL, 3],
]);

export const getBroadcastMessages = (store: IStore): IBroadcastMessage[] => {
  const allBroadcastMessages = Object.values(store.broadcastMessages.broadcastMessages);
  const now = Date.now();

  return sortBy(
    allBroadcastMessages
      .filter(({ isDismissed }) => !isDismissed)
      .filter(
        ({ startTime, endTime }) => now >= (startTime?.getTime() ?? 0) && now <= (endTime?.getTime() ?? Infinity),
      ),
    ({ type }) => BROADCAST_MESSAGE_TYPE_ORDER.get(type),
  );
};
